import React from "react";

const ToolsOptions = ({ data, compact }) => {
  // Ensure data is an array
  const items = Array.isArray(data) ? data : [data].filter(Boolean);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        padding: compact ? "0" : "40px 30px",
        gap: "12px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          width: "100%",
          maxWidth: "320px",
        }}
      >
        {items.map((item, index) => {
          if (!item) return null;

          // Check if item is a div with custom layout (for conversation buttons)
          if (
            item.type === "div" &&
            item.props &&
            item.props.style &&
            item.props.style.display === "flex"
          ) {
            return (
              <div
                key={item.key || index}
                style={{ width: "100%", ...item.props.style }}
              >
                {item.props.children}
              </div>
            );
          }

          // Extract props from React element
          const childProps = item.props || {};
          const textContent = childProps.children || "";
          const onClick = childProps.onClick;

          return (
            <div
              key={item.key || index}
              onClick={onClick}
              style={{
                backgroundColor: "#ffffff",
                border: "1px solid #e8e8e8",
                borderRadius: "10px",
                padding: "18px 24px",
                cursor: onClick ? "pointer" : "default",
                transition: "all 0.2s ease",
                textAlign: "right",
                direction: "rtl",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
                width: "100%",
              }}
              onMouseEnter={(e) => {
                if (onClick) {
                  e.currentTarget.style.backgroundColor = "#f8f9fa";
                  e.currentTarget.style.borderColor = "#d8d8d8";
                  e.currentTarget.style.boxShadow =
                    "0 2px 6px rgba(0, 0, 0, 0.12)";
                  e.currentTarget.style.transform = "translateY(-1px)";
                }
              }}
              onMouseLeave={(e) => {
                if (onClick) {
                  e.currentTarget.style.backgroundColor = "#ffffff";
                  e.currentTarget.style.borderColor = "#e8e8e8";
                  e.currentTarget.style.boxShadow =
                    "0 1px 3px rgba(0, 0, 0, 0.08)";
                  e.currentTarget.style.transform = "translateY(0)";
                }
              }}
            >
              <span
                style={{
                  fontSize: "15px",
                  fontWeight: "400",
                  color: "#2c3e50",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  letterSpacing: "0.01em",
                  display: "block",
                }}
              >
                {textContent}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ToolsOptions;
